import React from 'react'
import {
  DashboardOutlined,
  AppstoreOutlined,
  SolutionOutlined,
  ShopOutlined,
  TeamOutlined,
  SettingOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons'
import { useHistory, useLocation } from 'react-router-dom'
import type { ItemType } from 'antd/es/menu/interface'
import { useUser } from '../contexts/UserContext'
import { useConfig } from '../contexts/ConfigContext'
import { SideBar as SharedSideBar } from '@ryo/ui'

interface SideBarProps {
  activeKey: string
}

function getMenuItems(permissions: any): ItemType[] {
  const views = permissions?.views || []

  return [
    views.includes('admin.menu.sider.option.view.dashboard') && {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    views.includes('admin.menu.sider.option.view.company_list') && {
      key: 'companies',
      icon: <ShopOutlined />,
      label: 'Empresas',
    },
    views.includes('admin.menu.sider.option.view.module_list') && {
      key: 'modules',
      icon: <AppstoreOutlined />,
      label: 'Módulos',
    },
    views.includes('admin.menu.sider.option.view.plan_list') && {
      key: 'plans',
      icon: <SolutionOutlined />,
      label: 'Planes',
    },
    views.includes('admin.menu.sider.option.view.user_list') && {
      key: 'users',
      icon: <TeamOutlined />,
      label: 'Usuarios',
    },
    views.includes('admin.menu.sider.option.view.role_list') && {
      key: 'roles',
      icon: <SafetyCertificateOutlined />,
      label: 'Roles',
    },
    views.includes('admin.menu.configurations.option.view.module_settings') && {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Configuraciones',
    },
  ].filter(Boolean) as ItemType[]
}

const SideBar: React.FC<SideBarProps> = ({ activeKey }) => {
  const history = useHistory()
  const location = useLocation()
  const { config, updateConfig } = useConfig()
  const { user } = useUser()

  const menuItems = React.useMemo(() => getMenuItems(user.permissions), [user.permissions])

  const toggleCollapsed = () => {
    updateConfig({ sideCollapsed: !config.sideCollapsed })
  }

  const handleSelected = (key: string) => {
    history.push({
      pathname: `/index/${key}`,
      search: location.search
    })
  }

  return (
    <SharedSideBar
      activeKey={activeKey}
      collapsed={config.sideCollapsed}
      isMobile={config.isMobile}
      menuItems={menuItems}
      openKey={null}
      onToggle={toggleCollapsed}
      onSelect={handleSelected}
      onOpenChange={() => {}}
      title="Ryo Admin"
      logoSrc="/assets/icons/admin-sidebar.png"
    />
  )
}

export default SideBar
